<template>
  <div>
    <!-- 搜索筛选 -->
    <div class="query-select">
      <el-form :inline="true" :model="pageParams" class="user-search">
        <el-form-item label="姓名">
          <el-input
            style="width: 180px;"
            v-model.trim="pageParams.name"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            style="width: 180px;"
            v-model.trim="pageParams.phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            style="width: 180px;"
            v-model="pageParams.status"
            placeholder="请搜索状态"
          >
            <el-option label="正常" :value="0" />
            <el-option label="停用" :value="1" />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button plain round size="small"
          type="primary"
          icon="el-icon-search"
          @click="select"
          >查询</el-button
        >
        <el-button plain round size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetSelect"
          >重置</el-button
        >
        <el-button plain round size="small"
          type="success"
          icon="el-icon-plus"
          @click="dialogShow('add')"
          >新增</el-button
        >
        <el-button plain round size="small"
          type="success"
          icon="el-icon-upload2"
          @click="uploadOpen"
          >导入</el-button
        >
        <el-button plain round size="small"
          type="primary"
          icon="el-icon-download"
          @click="downloadExcel"
          >导出</el-button
        >
      </div>
    </div>
    <!--列表-->
    <div class="main-table">
      <el-table
        header-cell-class-name="table-header"
        stripe
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column align="center" type="index" width="60" label="序号">
        </el-table-column>

        <el-table-column
          align="center"
          prop="name"
          label="姓名"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="idCard"
          label="身份证号"
          width="320"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机号"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="prop"
          label="状态"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="0"
              :inactive-value="1"
              @change="statusChange(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="prop"
          label="操作"
          width="380"
        >
          <template slot-scope="scope">
            <el-button plain round size="small"
              type="warning"
              @click="dialogShow('edit', scope.row.memberWechatId)"
              >编辑</el-button
            >
            <el-button plain round size="small"
              type="primary"
              @click="openDetail(scope.row.memberWechatId)"
              >详情</el-button
            >
            <el-button plain round size="small"
              type="warning"
              @click="resetPassword(scope.row.memberWechatId)"
              >重置密码</el-button
            >
            <!-- <el-button plain round size="small"
              type="danger"
              @click="deleteData(scope.row)"
              >删除</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageParams.pageNum"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>
    <StudentsDialog ref="dialogRef" @success="select"></StudentsDialog>
    <StudentsDetail ref="detailDialogRef"></StudentsDetail>
    <UploadForm ref="uploadFormRef" @success="select"></UploadForm>
  </div>
</template>

<script>
import {
  getStudents,
  deleteStudent,
  editData,
  resetPassword,
  exportStudent
} from "@/api/student";
import download from "@/utils/download";
import StudentsDialog from "./StudentsDialog.vue";
import StudentsDetail from "./StudentsDetail.vue";
import UploadForm from "./UploadForm.vue";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      values: "",
      totals: 0,
      loading: false, //是显示加载
      listData: [], //用户数据
      // 分页参数
      pageParams: {
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  components: {
    StudentsDialog,
    StudentsDetail,
    UploadForm
  },
  /**
   * 创建完毕
   */
  created() {
    this.select();
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 查询
    async select() {
      this.loading = true;
      try {
        const result = await getStudents(this.pageParams);

        this.listData = result.data.rows;
        this.totals = result.data.total;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },

    resetSelect() {
      this.pageParams = {
        pageNum: 1,
        pageSize: 10
      };
      this.select();
    },
    uploadOpen() {
      this.$refs.uploadFormRef.open();
    },
    async downloadExcel() {
      const loading = Loading.service({ text: "导出中..." });
      try {
        const res = await exportStudent();
        download.excel(res.data, "学员信息.xlsx");
      } finally {
        loading.close();
      }
    },
    async resetPassword(id) {
      await this.$confirm(`确定重置该学员密码吗?`, "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      await resetPassword(id);
      this.$message.success("重置密码成功");
      this.select();
      // this.$refs.dialogRef.resetPassword(id);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.select();
    },
    openDetail(id) {
      this.$refs.detailDialogRef.open(id);
    },

    dialogShow(type, id = null) {
      this.$refs.dialogRef.open(type, id);
    },
    async statusChange(row) {
      // switch 已切到新值：0=开启，1=关闭
      const isOpen = row.status === 0;
      const message = isOpen
        ? "确认开启该学员学习权限，操作完成后有效期自动延长 1 年。"
        : "确认关闭该学员学习权限，操作完成后有效期自动修改为当前。";
      try {
        await this.$confirm(message, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        await editData(row);
        this.$message.success("状态修改成功");
        this.select();
      } catch (e) {
        row.status = isOpen ? 1 : 0;
      }
    },
    // 删除公司
    async deleteData(row) {
      try {
        await this.$confirm("确定要删除吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        const result = await deleteStudent(row.memberWechatId);

        this.$message.success("删除成功");
        this.select();
      } catch (e) {}
    }
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/students/index.vue